import { useQuery } from '@tanstack/react-query';
import { getBulletins } from '../api/v1/requests/bulletins';
import type { Bulletin } from '../api/v1/requests/bulletins';

export interface StudentBulletinFilters {
  search?: string;
  closed?: boolean | null;
  active?: boolean | null;
}

const sortBulletins = (items: Bulletin[]): Bulletin[] => {
  return [...items].sort((a, b) => {
    const aClosed = a.closed ? 1 : 0;
    const bClosed = b.closed ? 1 : 0;
    if (aClosed !== bClosed) return aClosed - bClosed;

    const aPending = a.verification_status === 'pending_review' ? 0 : 1;
    const bPending = b.verification_status === 'pending_review' ? 0 : 1;
    if (aPending !== bPending) return aPending - bPending;

    return new Date(b.date_create).getTime() - new Date(a.date_create).getTime();
  });
};

export const useBulletins = (filters: StudentBulletinFilters = {}) => {
  return useQuery<Bulletin[]>({
    queryKey: ['bulletins', filters],
    queryFn: async () => {
      const payload: Record<string, unknown> = { limit: 100, offset: 0 };
      if (filters.search?.trim()) {
        payload.search = filters.search.trim();
      }
      if (filters.closed !== null && filters.closed !== undefined) {
        payload.closed = filters.closed;
      }
      if (filters.active !== null && filters.active !== undefined) {
        payload.active = filters.active;
      }
      const data = await getBulletins(payload);
      return sortBulletins(data);
    },
  });
};
